import { OdinController } from '@myosh/odin-components';
import type { DropDownResult, HfDynamicFieldComponentProps } from '@myosh/odin-components';
import React from 'react';
import MultiselectPersonField from './multiselect-person-field.component';
import type { LookupTypeFieldProps, ReadersProps } from '../../../@types/forms';

interface HfMultiselectPersonFieldProps
  extends HfDynamicFieldComponentProps<DropDownResult[]>,
    LookupTypeFieldProps,
    ReadersProps {
  shouldUseCreatePortal?: boolean;
}

export default function HfReadersField(props: HfMultiselectPersonFieldProps) {
  const { name, control, value, onChange, ...rest } = props;

  return (
    <OdinController
      name={name as string}
      control={control}
      defaultValue={value}
      onChange={onChange}
      render={({ field: { ref: fieldRef, onChange, value }, fieldState: { error } }) => (
        <MultiselectPersonField
          {...rest}
          value={value}
          onChange={onChange}
          error={error?.message}
          inputRef={fieldRef}
          control={control}
        />
      )}
    />
  );
}
